import { getObjectName } from 'utils/utils'

export const INITIAL_STATE = {
    name: null,
    main_image: null,
    other_images: [],
    category_ids: [],
    brand_id: null,
    type_ids: [],
    sku: null,
    stock_quantity: null,
    weight: null,
    height: null,
    length: null,
    width: null,
    price: null,
    sale_price: null,
    sale_start: null,
    sale_end: null,
    description: null,
    how_to_use: null,
    ingredients: null,
    out_of_stock_label: null,
    limit_purchase: null,
    meta_title: null,
    meta_description: null,
    slug: null,
}

export const GET_FIELD_NAME = {
    name: 'Nama produk',
    category_ids: 'Kategori produk',
    brand_id: 'Brand',
    main_image: 'Foto Produk',
    sku: 'Kode SKU',
    stock_quantity: 'Stok',
    price: 'Harga Product',
    weight: 'Berat',
    description: 'Deskripsi',
}

export const FIELD_NAME_DETAIL = {
    ...GET_FIELD_NAME,
    type_ids: 'Tipe produk',
    height: 'Tinggi',
    length: 'Panjang',
    width: 'Lebar',
    sale_price: 'Harga diskon',
    sale_start: 'Start sale',
    sale_end: 'End sale',
    how_to_use: 'Cara penggunaan',
    ingredients: 'Ingredient',
    out_of_stock_label: 'Empty product label',
    limit_purchase: 'Limit purchase',
    meta_title: 'SEO title',
    meta_description: 'Description',
    slug: 'Slug',
}

export const SECTION_FIELDS = {
    general_info: getObjectName(INITIAL_STATE, 0, 6),
    product_data: getObjectName(INITIAL_STATE, 6, 16),
    product_info: getObjectName(INITIAL_STATE, 16, 19),
    product_page_setting: getObjectName(INITIAL_STATE, 19, 21),
    seo_setting: getObjectName(INITIAL_STATE, 21, 24),
}
